import { z } from 'zod';

export const documentIndexingAclHashSchema = z.string().regex(
  /^[0-9a-f]{64}$/,
  {
    error: 'Le hash ACL du job d’indexation est invalide.',
  },
);

export const documentIndexingUsageEventSchema = z.object({
  completion_tokens: z.number().int().nonnegative().nullable().optional(),
  duration_ms: z.number().int().nonnegative().nullable().optional(),
  external_id: z.string().trim().min(1),
  measurement_source: z.enum(['estimated', 'provider_reported']),
  metadata: z.record(z.string(), z.unknown()).nullable().optional(),
  model: z.string().trim().min(1).nullable().optional(),
  operation: z.string().trim().min(1),
  prompt_tokens: z.number().int().nonnegative().nullable().optional(),
  provider: z.string().trim().min(1).nullable().optional(),
  status: z.enum(['error', 'success']),
  total_tokens: z.number().int().nonnegative().nullable().optional(),
  type: z.enum(['document_indexing', 'document_retrieval']),
});

export const documentIndexingCallbackSchema = z.object({
  errorCode: z.string().trim().min(1).optional(),
  errorMessage: z.string().trim().min(1).optional(),
  generation: z.number().int().positive(),
  metrics: z.record(z.string(), z.unknown()).optional(),
  pageCount: z.number().int().positive().nullable().optional(),
  ragDocumentId: z.string().trim().min(1),
  status: z.enum(['completed', 'failed']),
  statusMessage: z.string().trim().min(1).optional(),
  usageEvents: z.array(documentIndexingUsageEventSchema).optional(),
});

export type DocumentIndexingCallbackDTO = z.infer<
  typeof documentIndexingCallbackSchema
>;
